module.exports = __webpack_public_path__ + "static/greybooties-4e670f3c990e9f498baab1c4d5f5a20c.png";